import React from 'react';

import AdminLayout from 'Pages/Admin/AdminLayout';

import { Loading } from 'Components/Partials';

import ChatApi from 'Services/Api/Admin/MainStage/Chat';
import { Socket, Toast, User } from 'Services';
import ChatMessage from 'Components/MainStage/ChatMessage';

export default class Chat extends React.Component {
    /**
     * @method state
     * @type {{meta: null, messages: [], working: boolean, sessionId: *}}
     */
    state = {
        messages: [],
        meta: null,
        working: false,
        sessionId: this.props.match.params.session,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.fetchMessages();

        Socket.getConnection()
            .private(`main_stage_chat.${this.state.sessionId}`)
            .listen('MainStageChat', (e) => {
                if (e.message.main_stage_chat_id === null) {
                    this.handleAddMessage(e.message);
                }
            })
            .listen('MainStageChatDeleted', (e) => this.handleDeleteMessage(e.message))
            .listen('subscription_error', console.error);

        document.addEventListener('scroll', this.loadMore);
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        document.removeEventListener('scroll', this.loadMore);

        Socket.getConnection().leave(`main_stage_chat.${this.state.sessionId}`);
    };

    /**
     * @method loadMore
     */
    loadMore = () => {
        const bottom = document.documentElement.scrollHeight - Math.ceil(document.documentElement.scrollTop) === document.documentElement.clientHeight;

        if (bottom) {
            this.fetchMessages();
        }
    };

    /**
     * @method fetchMessages
     * @return {Promise<void>}
     */
    fetchMessages = async () => {
        if (this.state.working || (this.state.meta !== null && this.state.meta?.current_page === this.state.meta?.last_page)) {
            return;
        }

        this.setState({ working: true });

        const request = await ChatApi.get({
            session: this.state.sessionId,
        }, {
            page: (this.state.meta?.current_page ?? 0) + 1,
        });

        if (request.success) {
            return this.setState({
                messages: [
                    ...this.state.messages,
                    ...request.data.data,
                ],
                meta: request.data.meta,
                working: false,
            });
        }

        Toast.error();
        this.setState({ working: false });
    };


    /**
     * @method handleAddMessage
     * @param {object} message
     */
    handleAddMessage = (message) => this.setState({
        messages: [
            message,
            ...this.state.messages,
        ],
    });

    /**
     * @method handleAddMessage
     * @param {object} message
     */
    handleDeleteMessage = (message) => this.setState({
        messages: this.state.messages.filter(m => m.id !== message.id),
    });

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { working, messages, meta } = this.state;

        return (
            <AdminLayout title="Main Stage - Chat">
                <div className="p-6">
                    {meta && (
                        <p className="font-bold mb-4">
                            Total : {meta.total}
                        </p>
                    )}

                    {messages.map((message, key) => (
                        <ChatMessage
                            admin={true}
                            message={message}
                            key={message.id}
                        />
                    ))}

                    {working && (
                        <Loading/>
                    )}
                </div>
            </AdminLayout>
        );
    }
}
